import { render, staticRenderFns } from "./AfterUseList.vue?vue&type=template&id=b8083770&scoped=true"
import script from "./AfterUseList.vue?vue&type=script&lang=js"
export * from "./AfterUseList.vue?vue&type=script&lang=js"
import style0 from "./AfterUseList.vue?vue&type=style&index=0&id=b8083770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8083770",
  null
  
)

export default component.exports